/**
 * WIM Product Selling Plan Selector
 * Handles subscription vs one-time purchase card selection.
 * Subscription card uses a div (not label) to avoid browser click hijacking on the custom select.
 */
(function() {

  function getHeaderPriceEls(container) {
    // Look upward for the product price block associated to this selling plan
    const section = container.closest('[id^="shopify-section-"]');
    if (!section) return [];
    return Array.from(section.querySelectorAll('[id^="Price-"] .price, [id^="StickyPrice-"] .price, [id^="StickyPrice-"] price-per-item'));
  }

  function updateHeaderPrice(container, selectedRadio) {
    const priceEls = getHeaderPriceEls(container);
    if (!priceEls.length) return;

    priceEls.forEach(priceEl => {
      if (selectedRadio.value === 'subscription') {
        // Cache original HTML once
        if (!priceEl.dataset.wimOriginalHtml) {
          priceEl.dataset.wimOriginalHtml = priceEl.innerHTML;
          priceEl.dataset.wimOriginalClass = priceEl.className;
        }
        const select = container.querySelector('[data-plan-select]');
        if (!select) return;
        const selected = select.options[select.selectedIndex];
        const subPrice = selected.getAttribute('data-price');      // e.g. "30,56 €"
        const comparePrice = selected.getAttribute('data-compare'); // e.g. "35,95 €"

        const regularEl = priceEl.querySelector('.price__regular');
        if (regularEl) regularEl.textContent = subPrice || '';

        // Show compare (original) price as sale/strikethrough
        if (comparePrice && comparePrice !== subPrice) {
          priceEl.classList.add('price--on-sale');
          let saleEl = priceEl.querySelector('.price__sale');
          if (!saleEl) {
            saleEl = document.createElement('span');
            saleEl.className = 'price__sale inline-flex items-center h-auto relative';
            priceEl.appendChild(saleEl);
          }
          saleEl.textContent = comparePrice;
          saleEl.style.display = '';
        }

        const stickyPlanText = priceEl.closest('.product-sticky-form__variant')?.querySelector('[data-sticky-selling-plan-text]');
        if (stickyPlanText) stickyPlanText.style.display = 'block';

      } else {
        // Restore original price HTML
        if (priceEl.dataset.wimOriginalHtml) {
          priceEl.innerHTML = priceEl.dataset.wimOriginalHtml;
          priceEl.className = priceEl.dataset.wimOriginalClass;
          delete priceEl.dataset.wimOriginalHtml;
          delete priceEl.dataset.wimOriginalClass;
        }

        const stickyPlanText = priceEl.closest('.product-sticky-form__variant')?.querySelector('[data-sticky-selling-plan-text]');
        if (stickyPlanText) stickyPlanText.style.display = 'none';
      }
    });
  }

  function updateSellingPlanState(container, selectedRadio) {
    if (!container || !selectedRadio) return;

    container.querySelectorAll('.wim-selling-plan-card').forEach(card => card.classList.remove('is-selected'));

    const activeCard = selectedRadio.closest('.wim-selling-plan-card');
    if (activeCard) activeCard.classList.add('is-selected');

    const hiddenInput = container.querySelector('input[name="selling_plan"]');

    if (hiddenInput) {
      if (selectedRadio.value === 'subscription') {
        const select = container.querySelector('[data-plan-select]');
        hiddenInput.value = select ? select.value : '';
      } else {
        hiddenInput.value = selectedRadio.value;
      }
    }

    updateHeaderPrice(container, selectedRadio);
  }

  function updateCardPrices(card, monthlyPrice, comparePrice, subtitle) {
    const priceEl = card.querySelector('[data-plan-monthly-price]');
    const compareEl = card.querySelector('[data-plan-compare]');
    const subtitleEl = card.querySelector('[data-plan-subtitle]');
    if (priceEl && monthlyPrice) priceEl.textContent = monthlyPrice;
    if (compareEl && comparePrice) compareEl.textContent = comparePrice;
    if (subtitleEl && subtitle) subtitleEl.textContent = subtitle;
  }

  function initCard(container) {
    const select = container.querySelector('[data-plan-select]');
    if (select && select.options.length > 0) {
      const firstOption = select.options[0];
      const card = container.querySelector('[data-group-type="subscription"]');
      if (card) {
        updateCardPrices(
          card,
          firstOption.getAttribute('data-monthly-price'),
          firstOption.getAttribute('data-compare'),
          firstOption.getAttribute('data-subtitle')
        );
      }
    }
    const checkedRadio = container.querySelector('.wim-plan-radio:checked');
    // Reset cached price on re-init so we always start fresh
    const priceEls = getHeaderPriceEls(container);
    priceEls.forEach(priceEl => {
      delete priceEl.dataset.wimOriginalHtml;
      delete priceEl.dataset.wimOriginalClass;
    });
    if (checkedRadio) updateSellingPlanState(container, checkedRadio);
  }

  // ---- Custom select: toggle open/close ----
  document.addEventListener('click', (e) => {

    // 1. Click on the custom select trigger → toggle dropdown
    const trigger = e.target.closest('.wim-custom-select-trigger');
    if (trigger) {
      e.stopPropagation();
      const customSelect = trigger.closest('.wim-custom-select');
      document.querySelectorAll('.wim-custom-select.is-open').forEach(el => {
        if (el !== customSelect) el.classList.remove('is-open');
      });
      customSelect.classList.toggle('is-open');
      return;
    }

    // 2. Click on a dropdown option → select it
    const optionEl = e.target.closest('.wim-custom-select-option');
    if (optionEl) {
      e.stopPropagation();
      const customSelect = optionEl.closest('.wim-custom-select');
      const textEl = customSelect.querySelector('.wim-custom-select-text');
      const value = optionEl.getAttribute('data-value');

      // Update visible text (keeps <strong> tags)
      textEl.innerHTML = optionEl.innerHTML;
      customSelect.classList.remove('is-open');

      // Sync hidden native select
      const wrapper = customSelect.closest('.wim-selling-plan-select-wrapper');
      const nativeSelect = wrapper ? wrapper.querySelector('select[data-plan-select]') : null;
      if (nativeSelect) {
        nativeSelect.value = value;

        // Update prices directly from option data attributes
        const card = wrapper.closest('.wim-selling-plan-card');
        if (card) {
          updateCardPrices(
            card,
            optionEl.getAttribute('data-monthly-price'),
            optionEl.getAttribute('data-compare'),
            optionEl.getAttribute('data-subtitle')
          );
        }

        // Ensure radio is checked and selling_plan input is updated
        const container = wrapper.closest('.wim-product-selling-plans');
        const radio = card ? card.querySelector('.wim-plan-radio') : null;
        if (radio && container) {
          radio.checked = true;
          updateSellingPlanState(container, radio);
        }
      }
      return;
    }

    // 3. Click outside any open custom select → close all
    if (!e.target.closest('.wim-custom-select')) {
      document.querySelectorAll('.wim-custom-select.is-open').forEach(el => el.classList.remove('is-open'));
    }

    // 4. Click on subscription card div → select radio
    const subCard = e.target.closest('[data-group-type="subscription"]');
    if (subCard) {
      const radio = subCard.querySelector('.wim-plan-radio');
      if (radio) {
        radio.checked = true;
        const container = subCard.closest('.wim-product-selling-plans');
        if (container) updateSellingPlanState(container, radio);
      }
      return;
    }

    // 5. Click on one-time card label → handled by browser, just sync state
    const card = e.target.closest('.wim-selling-plan-card');
    if (!card) return;
    const radio = card.querySelector('.wim-plan-radio');
    if (radio && !radio.checked) {
      radio.checked = true;
      const container = card.closest('.wim-product-selling-plans');
      if (container) updateSellingPlanState(container, radio);
    }
  });

  // Global init
  window.wimInitSellingPlans = function(context = document) {
    const containers = (context.querySelectorAll ? context : document).querySelectorAll('.wim-product-selling-plans');
    containers.forEach(initCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.wimInitSellingPlans());
  } else {
    window.wimInitSellingPlans();
  }

  document.addEventListener('wim:section:updated', (e) => {
    window.wimInitSellingPlans(e.detail?.container || document);
  });
})();

if (!customElements.get('wim-sibling-variants')) {
  class WimSiblingVariants extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.links = this.querySelectorAll('.wim-linked-variant-item');
      
      this.links.forEach(link => {
        link.addEventListener('click', this.onVariantClick.bind(this));
      });
    }

    onVariantClick(event) {
      if (event.currentTarget.classList.contains('is-active')) return;
      
      event.preventDefault();
      const url = event.currentTarget.getAttribute('href');
      const sectionToReplaceId = `shopify-section-${this.sectionId}`;
      const sectionContainer = document.getElementById(sectionToReplaceId);
      
      if (!sectionContainer) {
        window.location.href = url;
        return;
      }

      // Visual loading state
      sectionContainer.classList.add('wim-section-loading');
      
      // Fetch new section HTML
      const fetchUrl = url.includes('?') ? `${url}&section_id=${this.sectionId}` : `${url}?section_id=${this.sectionId}`;
      
      fetch(fetchUrl)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newSection = html.getElementById(sectionToReplaceId);
          
          if (newSection && newSection.innerHTML) {
            // Replace the entire section's innerHTML
            sectionContainer.innerHTML = newSection.innerHTML;
            // Update browser URL
            window.history.pushState({ path: url }, '', url);

            // Re-initialize custom logic and selling plans
            if (typeof window.wimInitSellingPlans === 'function') {
              window.wimInitSellingPlans(sectionContainer);
            }
            if (typeof window.wimInitBoughtTogether === 'function') {
              window.wimInitBoughtTogether(sectionContainer);
            }
            document.dispatchEvent(new CustomEvent('wim:section:updated', {
              bubbles: true,
              detail: { sectionId: this.sectionId, container: sectionContainer }
            }));
          } else {
            window.location.href = url;
          }
        })
        .catch(e => {
          console.error('[WIM] Sibling Variants fetch error:', e);
          window.location.href = url;
        })
        .finally(() => {
          sectionContainer.classList.remove('wim-section-loading');
        });
    }
  }

  customElements.define('wim-sibling-variants', WimSiblingVariants);

  // Handle browser back/forward navigation
  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.path) {
      window.location.href = e.state.path;
    }
  });
}
class WimDeliveryTimer extends HTMLElement {
  constructor() {
    super();
    this.textContainer = this.querySelector('[data-timer-text]');
    this.locationBtn = this.querySelector('[data-location-btn]');
    this.locationText = this.querySelector('[data-location-text]');
    this.modal = this.querySelector('[data-location-modal]');
    
    if (!this.textContainer) return;

    this.cutoffHour = parseInt(this.dataset.cutoff) || 14;
    this.minDays = parseInt(this.dataset.minDays) || 1;
    this.defaultMaxDays = parseInt(this.dataset.maxDays) || 2;
    this.currentMaxDays = this.defaultMaxDays;
    this.excludeWeekends = this.dataset.excludeWeekends === 'true';
    this.template = this.dataset.template || 'Haz tu pedido en [time] para recibirlo el [date].';

    this.initLocation();
    this.updateTimer();
    this.interval = setInterval(() => this.updateTimer(), 60000); // Update every minute
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  bindEvents() {
    if (!this.modal) return;
    
    const closeBtn = this.querySelector('[data-modal-close]');
    const submitBtn = this.querySelector('[data-zip-submit]');
    const input = this.querySelector('[data-zip-input]');
    const errorMsg = this.querySelector('[data-zip-error]');

    if (this.locationBtn) {
      this.locationBtn.addEventListener('click', () => {
        this.modal.showModal();
        input.value = localStorage.getItem('wim_user_zip') || '';
        errorMsg.classList.add('hidden');
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.modal.close());
    }

    // Close on backdrop click
    this.modal.addEventListener('click', (e) => {
      const dialogDimensions = this.modal.getBoundingClientRect();
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        this.modal.close();
      }
    });

    if (submitBtn && input) {
      submitBtn.addEventListener('click', async () => {
        const zip = input.value.trim();
        if (!/^\d{5}$/.test(zip)) {
          errorMsg.textContent = 'El cÃ³digo postal debe tener 5 dÃ­gitos.';
          errorMsg.classList.remove('hidden');
          return;
        }

        submitBtn.classList.add('is-loading');
        errorMsg.classList.add('hidden');

        try {
          const response = await fetch(`https://api.zippopotam.us/es/${zip}`);
          if (!response.ok) throw new Error('Not found');
          
          const data = await response.json();
          const city = data.places[0]['place name'];
          
          this.applyZipRules(zip, city);
          this.modal.close();
        } catch (err) {
          errorMsg.textContent = 'CÃ³digo postal no encontrado en EspaÃ±a.';
          errorMsg.classList.remove('hidden');
        } finally {
          submitBtn.classList.remove('is-loading');
        }
      });
    }
  }

  async initLocation() {
    const savedZip = localStorage.getItem('wim_user_zip');
    const savedCity = localStorage.getItem('wim_user_city');

    if (savedZip && savedCity) {
      this.applyZipRules(savedZip, savedCity);
    } else {
      // Try to fetch via IP
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        if (data && data.country_code === 'ES' && data.postal) {
          this.applyZipRules(data.postal, data.city || 'EspaÃ±a');
        }
      } catch (err) {
        console.log('GeoIP fail, using defaults');
      }
    }
  }

  applyZipRules(zip, city) {
    localStorage.setItem('wim_user_zip', zip);
    localStorage.setItem('wim_user_city', city);

    const prefix = zip.substring(0, 2);
    let newMaxDays = this.defaultMaxDays;

    if (prefix === '35' || prefix === '38') {
      newMaxDays = 5; // Canarias
    } else if (prefix === '07') {
      newMaxDays = 3; // Baleares
    } else if (prefix === '51' || prefix === '52') {
      newMaxDays = 4; // Ceuta y Melilla
    }

    this.currentMaxDays = newMaxDays;
    
    if (this.locationText) {
      this.locationText.textContent = `Enviar a ${city}, ${zip}`;
    }
    
    this.updateTimer();
  }

  updateTimer() {
    const now = new Date();
    let target = new Date(now);
    target.setHours(this.cutoffHour, 0, 0, 0);

    let isPastCutoff = now.getTime() >= target.getTime();

    if (this.excludeWeekends) {
      const currentDay = now.getDay();
      if (currentDay === 0) { // Sunday
        target.setDate(target.getDate() + 1);
        isPastCutoff = false;
      } else if (currentDay === 6) { // Saturday
        target.setDate(target.getDate() + 2);
        isPastCutoff = false;
      } else if (currentDay === 5 && isPastCutoff) { // Friday after cutoff
        target.setDate(target.getDate() + 3);
      } else if (isPastCutoff) {
        target.setDate(target.getDate() + 1);
      }
    } else if (isPastCutoff) {
      target.setDate(target.getDate() + 1);
    }

    const diffMs = target.getTime() - now.getTime();
    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    let timeStr = '';
    if (diffHrs > 0) timeStr += `${diffHrs} hora${diffHrs !== 1 ? 's' : ''} `;
    timeStr += `${diffMins} minuto${diffMins !== 1 ? 's' : ''}`;

    // Calculate Delivery Date
    let deliveryDate = new Date(target);
    deliveryDate.setHours(0,0,0,0);
    
    // Add transit days based on ZIP rules
    let daysToAdd = this.currentMaxDays;
    while (daysToAdd > 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      if (this.excludeWeekends) {
        const day = deliveryDate.getDay();
        if (day === 0 || day === 6) continue;
      }
      daysToAdd--;
    }

    const dateOptions = { weekday: 'long', day: 'numeric', month: 'short' };
    let dateStr = new Intl.DateTimeFormat('es-ES', dateOptions).format(deliveryDate);
    dateStr = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
    
    let finalHtml = this.template
      .replace('\\[time\\]', timeStr)
      .replace('\\[date\\]', dateStr)
      .replace('[time]', timeStr)
      .replace('[date]', dateStr);

    this.textContainer.innerHTML = finalHtml;
  }
}

if (!customElements.get('wim-delivery-timer')) {
  customElements.define('wim-delivery-timer', WimDeliveryTimer);
}

/**
 * WIM Featured Reviews (Judge.me Custom Fetch + CSS Scroll Snap Carousel)
 */
(function() {
  function initNavButtons(container) {
    const track = container.querySelector('[data-wim-reviews-grid]');
    const prevBtn = container.querySelector('[data-wim-reviews-prev]');
    const nextBtn = container.querySelector('[data-wim-reviews-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function getCardWidth() {
      const firstCard = track.querySelector('.wim-review-card');
      if (!firstCard) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      return firstCard.offsetWidth + gap;
    }

    function updateButtons() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 2;
    }

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  }

  function initWimFeaturedReviews() {
    const containers = document.querySelectorAll('[data-wim-reviews-container]');
    containers.forEach(container => {
      if (container.dataset.loaded) return;
      container.dataset.loaded = 'true';

      const handle = container.dataset.productHandle;
      const shopDomain = container.dataset.shopDomain;
      const limit = parseInt(container.dataset.limit) || 3;
      const minStars = parseInt(container.dataset.minStars) || 4;
      const token = container.dataset.token;
      const grid = container.querySelector('[data-wim-reviews-grid]');

      if (!handle || !grid) return;

      const url = `https://judge.me/api/v1/widgets/product_review?api_token=${token}&shop_domain=${shopDomain}&handle=${handle}`;

      fetch(url)
        .then(r => r.json())
        .then(data => {
          if (!data || !data.widget) return;
          
          const parser = new DOMParser();
          const doc = parser.parseFromString(data.widget, 'text/html');
          
          const reviews = Array.from(doc.querySelectorAll('.jdgm-rev'));
          const filteredReviews = reviews.filter(rev => {
            const scoreAttr = rev.querySelector('.jdgm-rev__rating')?.getAttribute('data-score');
            const score = parseInt(scoreAttr) || 0;
            return score >= minStars;
          }).slice(0, limit);

          if (filteredReviews.length === 0) {
            container.style.display = 'none';
            return;
          }

          filteredReviews.forEach(rev => {
            const author = rev.querySelector('.jdgm-rev__author')?.textContent || '';
            const title = rev.querySelector('.jdgm-rev__title')?.textContent || '';
            const body = rev.querySelector('.jdgm-rev__body')?.textContent || '';
            const score = parseInt(rev.querySelector('.jdgm-rev__rating')?.getAttribute('data-score')) || 5;

            let starsHtml = '';
            for(let i=0; i<5; i++) {
              if (i < score) {
                starsHtml += '<svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" style="color:rgb(var(--color-highlight));"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
              } else {
                starsHtml += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16" style="color:rgb(var(--color-border-dark));"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
              }
            }

            const cardHtml = `
              <div class="wim-review-card">
                <div class="wim-review-card__stars">${starsHtml}</div>
                <div class="wim-review-card__title">${title}</div>
                <p class="wim-review-card__body">${body}</p>
                <div class="wim-review-card__author">${author}</div>
              </div>
            `;
            const productCard = grid.querySelector('[data-wim-product-card]');
            // Insert reviews after the product card (append to grid)
            grid.insertAdjacentHTML('beforebegin', cardHtml);
          });

          // Wire up nav buttons after cards are injected
          initNavButtons(container);
        })
        .catch(e => console.error('[WIM] Error fetching Judge.me reviews', e));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWimFeaturedReviews);
  } else {
    initWimFeaturedReviews();
  }
  document.addEventListener('shopify:section:load', initWimFeaturedReviews);
})();

/* ==========================================================================
   WIM Variant Popover Component (Bundle Cards)
   ========================================================================== */
if (!customElements.get('wim-variant-popover')) {
  class WimVariantPopover extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.wim-variant-popover__trigger');
      this.menu = this.querySelector('.wim-variant-popover__menu');
      this.label = this.querySelector('.wim-variant-popover__label');
      this.options = this.querySelectorAll('.wim-variant-popover__option');
      this.card = this.closest('.product-card');

      if (!this.trigger || !this.menu) return;

      this._onTriggerClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle();
      };
      this.trigger.addEventListener('click', this._onTriggerClick);

      this._onOptionClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const option = e.currentTarget;
        this.selectOption(option);
      };
      this.options.forEach(option => {
        option.addEventListener('click', this._onOptionClick);
      });

      this._onOutsideClick = (e) => {
        if (!this.contains(e.target)) {
          this.close();
        }
      };
      document.addEventListener('click', this._onOutsideClick);

      this._onKeyDown = (e) => {
        if (e.key === 'Escape') this.close();
      };
      document.addEventListener('keydown', this._onKeyDown);
    }

    disconnectedCallback() {
      if (this._onOutsideClick) document.removeEventListener('click', this._onOutsideClick);
      if (this._onKeyDown) document.removeEventListener('keydown', this._onKeyDown);
    }

    toggle() {
      const isOpen = !this.menu.hasAttribute('hidden');
      if (isOpen) {
        this.close();
      } else {
        document.querySelectorAll('wim-variant-popover').forEach(p => p !== this && p.close());
        this.open();
      }
    }

    open() {
      this.menu.removeAttribute('hidden');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
    }

    close() {
      this.menu.setAttribute('hidden', '');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');
    }

    selectOption(option) {
      const variantId = option.getAttribute('data-variant-id');
      const variantTitle = option.getAttribute('data-variant-title');
      const variantPrice = option.getAttribute('data-variant-price');
      const variantImage = option.getAttribute('data-variant-image');

      if (this.label && variantTitle) {
        this.label.textContent = variantTitle;
      }

      this.options.forEach(opt => opt.classList.toggle('is-selected', opt === option));

      if (this.card) {
        // Update hidden input in form so bundle add-to-cart uses new variant
        const idInput = this.card.querySelector('form[is="product-bundle-form"] [name="id"]');
        if (idInput) {
          idInput.value = variantId;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Update displayed price in card
        const priceItem = this.card.querySelector('.price__regular .price-item--regular, .price__regular');
        if (priceItem && variantPrice) {
          const innerPrice = priceItem.querySelector('.price-item') || priceItem;
          innerPrice.textContent = variantPrice;
        }

        // Update image if variant has its own image
        if (variantImage) {
          const img = this.card.querySelector('.product-card__media img');
          if (img) {
            img.src = variantImage;
            img.removeAttribute('srcset');
          }
        }
      }

      this.close();
    }
  }

  customElements.define('wim-variant-popover', WimVariantPopover);
}

/**
 * WIM Product Blog Block Loader
 * Renders embedded product card when <div class="product-blog__block" data-handle="handle"> is present.
 * Also handles instances where content creators pasted the snippet directly into the WYSIWYG visual editor as plain text.
 */
function convertRawTextBlogBlocks() {
  const container = document.querySelector('.wim-article-body') || document.querySelector('.rte');
  if (!container) return;

  const candidates = container.querySelectorAll('p');
  candidates.forEach(el => {
    const text = el.textContent || '';
    if (text.includes('product-blog__block') && text.includes('data-handle')) {
      const match = text.match(/data-handle=["']?([^"'\s>]+)["']?/i);
      if (match && match[1]) {
        const handle = match[1].trim();
        const block = document.createElement('div');
        block.className = 'product-blog__block';
        block.setAttribute('data-handle', handle);

        const prev = el.previousElementSibling;
        if (prev && prev.tagName === 'P' && prev.textContent.trim() === '') {
          prev.remove();
        }
        const next = el.nextElementSibling;
        if (next && next.tagName === 'P' && next.textContent.trim() === '') {
          next.remove();
        }

        el.replaceWith(block);
      }
    }
  });
}

function initProductBlogBlocks() {
  convertRawTextBlogBlocks();

  const blocks = document.querySelectorAll('.product-blog__block[data-handle]:not([data-wim-initialized])');
  if (!blocks.length) return;

  blocks.forEach(block => {
    block.setAttribute('data-wim-initialized', 'true');
    const handle = block.getAttribute('data-handle');
    if (!handle) return;

    if (block.querySelector('.wim-product-blog-card')) return;

    // Show sleek loading skeleton
    block.innerHTML = `
      <div class="wim-product-blog-card wim-product-blog-card--skeleton">
        <div class="wim-product-blog-card__media-wrapper wim-skeleton-box"></div>
        <div class="wim-product-blog-card__info">
          <div class="wim-skeleton-line" style="width: 70%; height: 20px;"></div>
          <div class="wim-skeleton-line" style="width: 45%; height: 14px;"></div>
          <div class="wim-skeleton-line" style="width: 30%; height: 22px;"></div>
          <div class="wim-skeleton-line" style="width: 40%; height: 16px;"></div>
          <div class="wim-skeleton-line" style="width: 160px; height: 42px; border-radius: 9999px;"></div>
        </div>
      </div>
    `;

    // Try Section Rendering API first to get complete Liquid-rendered card
    const sectionUrl = `/products/${encodeURIComponent(handle)}?section_id=wim-product-blog-card`;
    
    fetch(sectionUrl)
      .then(res => {
        if (!res.ok) throw new Error('Section render failed');
        return res.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const card = doc.querySelector('.wim-product-blog-card');
        if (card) {
          block.innerHTML = '';
          block.appendChild(card);
        } else {
          throw new Error('Card not found in section response');
        }
      })
      .catch(() => {
        // Fallback: Fetch product JSON API
        fetch(`/products/${encodeURIComponent(handle)}.js`)
          .then(res => {
            if (!res.ok) throw new Error('Product JSON failed');
            return res.json();
          })
          .then(product => {
            renderProductBlogCardFromJSON(block, product);
          })
          .catch(err => {
            console.warn(`[WIM] Could not load product for blog block: ${handle}`, err);
            block.style.display = 'none';
          });
      });
  });
}

function renderProductBlogCardFromJSON(container, product) {
  const priceFormatted = (product.price / 100).toFixed(2).replace('.', ',') + ' €';
  const compareFormatted = product.compare_at_price > product.price 
    ? (product.compare_at_price / 100).toFixed(2).replace('.', ',') + ' €' 
    : '';
  const imageSrc = product.featured_image || (product.images && product.images[0]) || '';
  const subtitle = product.type || '';

  const singleStarSvg = '<svg class="wim-star" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M5.36666 5.14746L6.99041 1.87746C7.03767 1.78283 7.11037 1.70323 7.20034 1.6476C7.29031 1.59197 7.394 1.5625 7.49978 1.5625C7.60556 1.5625 7.70925 1.59197 7.79923 1.6476C7.8892 1.70323 7.96189 1.78283 8.00916 1.87746L9.63291 5.14746L13.2629 5.67496C13.3676 5.68948 13.4661 5.73315 13.5472 5.80097C13.6283 5.8688 13.6887 5.95805 13.7214 6.05854C13.7542 6.15904 13.7581 6.26672 13.7326 6.36931C13.7071 6.4719 13.6533 6.56525 13.5773 6.63871L10.951 9.18246L11.571 12.7762C11.6504 13.2375 11.1629 13.5887 10.746 13.3712L7.49978 11.6737L4.25291 13.3712C3.83666 13.5893 3.34916 13.2375 3.42853 12.7756L4.04853 9.18184L1.42228 6.63809C1.34665 6.56457 1.29316 6.47131 1.26789 6.36891C1.24261 6.26651 1.24658 6.15907 1.27933 6.0588C1.31207 5.95854 1.37229 5.86948 1.45314 5.80173C1.53398 5.73399 1.63221 5.69029 1.73666 5.67559L5.36666 5.14746Z" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const starsSvg = singleStarSvg.repeat(5);

  container.innerHTML = `
    <div class="wim-product-blog-card" data-product-id="${product.id}">
      <a href="${product.url}" class="wim-product-blog-card__media-wrapper reversed-link" aria-label="${product.title}">
        ${imageSrc ? `<img src="${imageSrc}" class="wim-product-blog-card__image" alt="${product.title}" loading="lazy" />` : ''}
      </a>
      <div class="wim-product-blog-card__info">
        <div class="wim-product-blog-card__headings">
          <a href="${product.url}" class="wim-product-blog-card__title reversed-link">${product.title}</a>
          ${subtitle ? `<div class="wim-product-blog-card__subtitle">${subtitle}</div>` : ''}
        </div>
        <div class="wim-product-blog-card__pricing">
          ${compareFormatted ? `<s class="wim-product-blog-card__price-compare">${compareFormatted}</s>` : ''}
          <span class="wim-product-blog-card__price ${compareFormatted ? 'wim-product-blog-card__price--sale' : ''}">${priceFormatted}</span>
        </div>
        <div class="wim-product-blog-card__rating">
          <div class="wim-product-blog-card__stars" aria-hidden="true">${starsSvg}</div>
          <span class="wim-product-blog-card__rating-count">(124)</span>
        </div>
        <div class="wim-product-blog-card__action">
          <a href="${product.url}" class="wim-product-blog-card__btn button button--primary">
            <span class="btn-fill" data-fill></span>
            <span class="btn-text">VER PRODUCTO</span>
          </a>
        </div>
      </div>
    </div>
  `;
}

if (document.readyState !== 'loading') {
  initProductBlogBlocks();
} else {
  document.addEventListener('DOMContentLoaded', initProductBlogBlocks);
}
document.addEventListener('shopify:section:load', initProductBlogBlocks);

function convertCountryLocalizationLinks() {
  var countryToHreflang = {
    ES: 'es-ES',
    US: 'en-US',
    FR: 'fr-FR',
    IT: 'it-IT',
    DE: 'de-DE',
    MX: 'es-MX',
    GB: 'en-US'
  };

  var alternateLinks = Array.from(
    document.querySelectorAll('link[rel="alternate"][hreflang]')
  );

  var countryOptions = document.querySelectorAll(
    'a[data-country-code]'
  );

  if (!countryOptions.length) {
    return;
  }

  countryOptions.forEach(function(option) {
    var countryCode = option.getAttribute('data-country-code');
    var targetHreflang = countryToHreflang[countryCode];

    if (!targetHreflang) {
      return;
    }

    var match = alternateLinks.find(function(link) {
      var hreflang = link.getAttribute('hreflang');

      return (
        hreflang &&
        hreflang.toLowerCase() === targetHreflang.toLowerCase()
      );
    });

    if (!match) {
      return;
    }

    var href = match.getAttribute('href');

    if (!href) {
      return;
    }

    if (
      option.getAttribute('href') === href &&
      option.getAttribute('hreflang') === targetHreflang
    ) {
      return;
    }

    option.setAttribute('href', href);
    option.setAttribute('hreflang', targetHreflang);

    console.log(
      '[COUNTRY LINKS]',
      countryCode,
      '→',
      targetHreflang,
      '→',
      href
    );
  });
}


function initCountryLocalizationLinks() {

  convertCountryLocalizationLinks();

  var observer = new MutationObserver(function(mutations) {
    var shouldProcess = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        shouldProcess = true;
      }
    });
    if (!shouldProcess) {
      return;
    }
    convertCountryLocalizationLinks();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

initCountryLocalizationLinks();

// Selling Plan Selector Custom Element
if (!customElements.get('wim-plan-select')) {
  customElements.define('wim-plan-select', class WimPlanSelect extends HTMLElement {
    connectedCallback() {
      this._onClick = (e) => {
        const trigger = e.target.closest('.wim-selling-plan__trigger');
        if (trigger && this.contains(trigger)) {
          this.toggle(e);
          return;
        }

        const option = e.target.closest('.wim-selling-plan__option');
        if (option && this.contains(option)) {
          this.onSelect(option, e);
          return;
        }
      };

      this._onKeyDown = (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) {
          this.close();
          this.querySelector('.wim-selling-plan__trigger')?.focus();
          return;
        }

        const option = e.target.closest('.wim-selling-plan__option');
        if (option && this.contains(option) && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          this.onSelect(option, e);
        }
      };

      this._onDocClick = (e) => {
        if (!this.contains(e.target)) {
          this.close();
        }
      };

      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeyDown);
      document.addEventListener('click', this._onDocClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeyDown);
      document.removeEventListener('click', this._onDocClick);
    }

    toggle(e) {
      e?.stopPropagation();
      const willOpen = !this.classList.contains('is-open');
      document.querySelectorAll('wim-plan-select.is-open').forEach((el) => {
        if (el !== this) el.close();
      });
      if (willOpen) {
        const rect = this.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        if (spaceBelow < 180) {
          this.classList.add('is-dropup');
        } else {
          this.classList.remove('is-dropup');
        }
        this.classList.add('is-open');
        this.querySelector('.wim-selling-plan__trigger')?.setAttribute('aria-expanded', 'true');
      } else {
        this.close();
      }
    }

    close() {
      this.classList.remove('is-open');
      this.classList.remove('is-dropup');
      this.querySelector('.wim-selling-plan__trigger')?.setAttribute('aria-expanded', 'false');
    }

    onSelect(opt, e) {
      e?.stopPropagation();
      const value = opt.getAttribute('data-value') ?? '';
      const select = this.querySelector('select[name="selling-plan"]');
      if (select && select.value !== value) {
        const titleHtml = opt.querySelector('.wim-selling-plan__option-title')?.innerHTML;
        const detailHtml = opt.querySelector('.wim-selling-plan__option-detail')?.innerHTML;
        const triggerLabel = this.querySelector('.wim-selling-plan__label');
        const triggerDetail = this.querySelector('.wim-selling-plan__detail');
        if (triggerLabel && titleHtml) triggerLabel.innerHTML = titleHtml;
        if (triggerDetail) triggerDetail.innerHTML = detailHtml || '';
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.close();
    }
  });
}

document.addEventListener(
  'click',
  function(event) {
    var countryLink = event.target.closest(
      'a[data-country-code]'
    );

    if (!countryLink) {
      return;
    }

    if (
      countryLink.classList.contains('pointer-events-none') ||
      countryLink.getAttribute('aria-current') === 'true'
    ) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var href = countryLink.getAttribute('href');

    if (!href || href === '#') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    window.location.assign(href);
  },
  true
);